<script setup lang="ts">
import _ from "lodash";
const authStore = useAuthStore();
const user = computed(() => authStore.user);
</script>

<template>

<div
  v-if="user"
  class="flex items-center space-x-2">

  <UAvatar
    :alt="user.discordUsername?.toUpperCase()"
    class="size-6" />

  <div class="flex flex-col space-y-0.5">
    <h1 class="font-semibold text-xs text-gray-500 dark:text-gray-400">
      {{ _.capitalize(user.discordUsername) }}
    </h1>
    <span class="
      flex items-center group
      font-mono text-xs font-medium text-gray-950 dark:text-gray-300">
      {{ ellipsis(user.accountAddress) }}
      <GenericClipboard
        :text="user.accountAddress"
        class="group-hover:opacity-100 opacity-0 ml-1.5" />
    </span>

  </div>

</div>

</template>
